module.exports = __webpack_public_path__ + "f4bf47aaae4e3b9d652a07b232489fec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/make-moves-together/cha-feed.png
// module id = 1750
// module chunks = 1